import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type OrgAddress = {
  addressId: number;
  orgId: number;
  address1: string;
  address2?: string;
  town?: string;
  city?: string;
  zip?: string;
  country?: string;
};

type AddressesResponse = {
  addressList?: Array<Record<string, unknown>>;
  AddressList?: Array<Record<string, unknown>>;
};

function pickAddress(item: Record<string, unknown>): OrgAddress {
  return {
    addressId: Number(item.addressId ?? item.AddressId ?? 0),
    orgId: Number(item.orgId ?? item.OrgId ?? 0),
    address1: String(item.address1 ?? item.Address1 ?? ""),
    address2: item.address2 != null ? String(item.address2) : undefined,
    town: item.town != null ? String(item.town) : undefined,
    city: item.city != null ? String(item.city) : undefined,
    zip: item.zip != null ? String(item.zip) : undefined,
    country: item.country != null ? String(item.country) : undefined,
  };
}

/**
 * Reads an organisation's addresses.
 *
 * This used to POST `Read_All_Org_Addresses_By_Org_ID`, which does not exist -
 * not in the API and not in CoreSc - so the call 404'd every time. There is no
 * read-all-addresses-by-org anywhere in Core, but `ReadOrganisationComplete`
 * already returns the org's `addressList`, so we read it from there rather than
 * add an endpoint.
 */
export async function readOrgAddresses(
  accessToken: string,
  orgId: number
): Promise<VgApiResult<OrgAddress[]>> {
  const { data, error } = await vgApiRequest<AddressesResponse>(
    accessToken,
    "ReadOrganisationComplete",
    { orgId }
  );
  if (error) return { data: null, error };
  const list = data?.addressList ?? data?.AddressList ?? [];
  return { data: list.map(pickAddress), error: null };
}
